<!-- 方案简介 -->
<template>
    <div class="introduction-container">
      <div v-html="introduction"></div>
    </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      introduction: {
        type: String,
        default: ''
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {}
  }
</script>

<style lang="scss">
.introduction-container{
  padding: rem(20);
  line-height: rem(21);
  overflow: hidden;
  word-break: break-word;
  img{
    width: 100%;
    height: auto;
  }
}
</style>
